export default __webpack_public_path__ + "static/media/Monk's Bracers of the Limitless Cipher.7cc3b125.jpg";